import { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
import useCountry from '../hooks/useCountry';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import { FaExclamationTriangle } from '@react-icons/all-files/fa/FaExclamationTriangle';

import TopHeader from '../components/TopHeader';
import AboutCompanyCard from '../components/AboutCompanyCard';
import OurCommitmentCard from '../components/OurCommitmentCard';
import ErrorPage from '../pages/ErrorPage';
import Footer from '../components/Footer';

import FeedbackFormContainer from 'feedback-forms/forms/FeedbackFormContainer';

import axios from '../utils/axios';
// import PersonalisedIntroText from '../components/PersonalisedIntroText';
// ------------------------------------------------------------------------------------------

function WritePage(props)
{
    const country = useCountry();
    const [ loading, setLoading ] = useState(true);
    const [ error, setError ] = useState(false);    
    const [ company, setCompany ] = useState(null);
    const [ inviteData, setInviteData ] = useState(null);
    const [ isQrCode, setIsQrCode ] = useState(false);
    const [ isTapPlate, setIsTapPlate ] = useState(false);


    useEffect( () => { 
        setLoading(true);
        setError(false);

        // Use inviteData if we have it, otherwise we can grab the company ID (or fail)
        if ( props?.inviteData?.company?.id > 0 )
        {
            // console.log('Form is using inviteData');
            setCompany( props?.inviteData?.company );
            setInviteData( props?.inviteData );
            setLoading(false);
        }
        if ( props?.companyID?.length > 0 && company === null )
        {
            axios.get(`/company/${props.companyID}?country=${country?.id}`)
            .then((response) => {             
                setCompany( response.data );
                setLoading(false);
                document.title = `Write a review for ${response?.data?.name}, ${response?.data?.address?.postcode?.toUpperCase()} | Working Feedback ${country?.iso_code}`;
                document.getElementById('canonical').setAttribute('rel', 'canonical');
                document.getElementById('canonical').setAttribute('href', `${response?.data?.country?.urls?.rpp}/write/${response?.data?.url_slug}`);
                document.getElementById('opengraph_title').setAttribute('content', `Write a review for ${response?.data?.name}, ${response?.data?.address?.postcode?.toUpperCase()}`);
                document.getElementById('opengraph_description').setAttribute('content', `Share your thoughts on ${response?.data?.name} by leaving a review.`);
                document.getElementById('opengraph_image').setAttribute('content', `https://api9.workingfeedback.co.uk/company/${response?.data?.id}/social.jpg`);
            })
            .catch((response) => { 
                console.warn(response);
                setError(true);
            });

            if ( props?.qrCode === true ) {
                setIsQrCode(true);
            }

            if ( props?.tapPlate === true ) {
                setIsTapPlate(true);
            }
        }        
        // eslint-disable-next-line
    }, []);

    return ( 
        <>            
            { /* Loading */ }
            { loading && !error && ( 
                <Box sx={{ width: '100%', height: '100%', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                    <CircularProgress color="primaryNavy" />
                </Box>
            )}

            { /* Error state */ }
            { !loading && error && ( <ErrorPage content={
                <Stack direction="column">
                    <Typography component="div" variant="h2">
                        <FaExclamationTriangle />
                    </Typography>
                    <Typography component="div">
                        An error occurred. Please refresh the page to try again.
                    </Typography>
                </Stack>
            } /> )}

            { /* Layout when loading complete and API calls have completed successfully */ }            
            { !loading && !error && ( 
            <>
                <TopHeader minimal companyID={props?.companyID} />
                <Container>
                    <Grid container spacing={5} pt={5} pb={8} 
                        alignItems={inviteData === null ? 'flex-start' : 'center'}
                        justifyContent={inviteData === null && (props?.qrCode === false && props?.tapPlate === false) ? 'flex-start' : 'center'}>

                        { /* Left column (main page content) */ }
                        <Grid item xs={12} sm={12} md={8} lg={8} >
                            <Typography variant="h5" component="h2" style={{ marginTop: '-15px' }} mb={inviteData?.hasOwnProperty('questionSet') === true ? 1 : 4}>Review {company?.name}</Typography>
                            { /* {inviteData?.hasOwnProperty('questionSet') === true && ( <PersonalisedIntroText inviteData={inviteData} /> )} */ }

                        { company?.subscriber === false && 
                        <Box sx={{ marginBottom: '30px' }}>
                            <Alert severity="warning">
                                This location does not subscribe to the Working Feedback service
                            </Alert>
                        </Box>
                        }

                            <Card sx={{ minHeight: '700px' }}>
                                <CardContent>
                                    <FeedbackFormContainer withCard={false} skipIntro={inviteData?.hasOwnProperty('questionSet') === true} companyID={company?.id} qrCode={isQrCode} tapPlate={isTapPlate} inviteData={inviteData} />
                                </CardContent>
                            </Card>
                        </Grid>

                        { /* Sidebar - but not if we have invite data */ }
                        { inviteData === null && props?.qrCode === false && props?.tapPlate === false && (
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Stack spacing={3}>
                                <AboutCompanyCard loading={loading} company={company} />
                                <OurCommitmentCard />
                            </Stack>
                        </Grid>
                        )}

                    </Grid>
                                    
                </Container>
                <Footer />
            </>
            )}
            
        </>
    )
}

export default WritePage;